
import './Ad_menu.scss';
import * as S from '../../scss/theme';
import fnc from '../../mymod/commFunction';
import HongButton from '../../comm/HongButton';
import HeaderTitle from '../../comm/HeaderTitle';
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';

const Ad_menu = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [list, setList] = useState([]);
  const [title, setTitle] = useState('관리자 메뉴');
//=========================================
  return (

  <S.Section>
    <HeaderTitle  title={title} direction={1} onBackClick={() => navigate(-1)} />
    <div className='Ad_menu'>
   
      <section className='sec-menu'>
        <HongButton className='btn h-btn-dark'
          onClick={() => navigate('/ad_adminsions_consultant_app')} >입시컨설턴트 운용계약서</HongButton>
      </section>

      {/* <section className='sec-menu'>
        <HongButton className='btn h-btn-dark'
          onClick={() => navigate('/Ujab_write')} >알쓸우잡 입력 입력</HongButton>
      </section> */}

       <section className='sec-menu'>
        <HongButton className='btn h-btn-dark'
          onClick={() => navigate('/ujab_board')} >알쓸우잡</HongButton>
      </section>

    </div>
  </S.Section>
  );
};

export default Ad_menu;